import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitEmbedClassicRoute: InvariantJiraRoute = {
	name: 'software-form-submit-classic-embed',
	path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
	exact: true,
};
